import React from "react";

export function DeliveryIcon(): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.44 9.03L15.41 5H11V7H14.59L16.59 9H5C2.2 9 0 11.2 0 14C0 16.8 2.2 19 5 19C7.46 19 9.45 17.31 9.9 15H11.55L14.32 12.23C14.11 12.77 14 13.37 14 14C14 16.8 16.2 19 19 19C21.8 19 24 16.8 24 14C24 11.35 22.03 9.23 19.44 9.03ZM7.82 15C7.4 16.15 6.28 17 5 17C3.37 17 2 15.63 2 14C2 12.37 3.37 11 5 11C6.28 11 7.4 11.85 7.82 13H5V15H7.82ZM16 14C16 15.66 17.34 17 19 17C20.66 17 22 15.66 22 14C22 12.34 20.66 11 19 11C17.34 11 16 12.34 16 14Z"
        fill="black"
      />
    </svg>
  );
}
